/**
 * Mobile Menu Button
 * Shared hamburger menu button for mobile navigation
 */

import { Button } from '../../../components/ui/button'
import { Menu } from '../../../icons'
import type { MobileMenuButtonProps } from './types'

export function MobileMenuButton({ onClick }: MobileMenuButtonProps) {
  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={onClick}
      className="h-10 w-10 rounded-xl hover:bg-secondary transition-all flex-shrink-0"
      aria-label="Open menu"
    >
      <Menu className="w-5 h-5 text-muted-foreground" />
    </Button>
  )
}
